module.exports = __webpack_public_path__ + "static/tabc-badge-sm@2x-329de13f51f4e22efd75be590eeee0d0.png";